// Lógica de prioridades de saúde — gera opções dinâmicas com base nas respostas do diagnóstico

export interface PrioridadeOpcao {
  id: string
  label: string
}

export interface GrupoPrioridades {
  titulo: string
  opcoes: PrioridadeOpcao[]
}

// Todas as opções possíveis, organizadas por grupo
export const PRIORIDADES_FISICAS: PrioridadeOpcao[] = [
  { id: 'Sono e descanso', label: 'Sono e descanso' },
  { id: 'Energia e disposição', label: 'Energia e disposição' },
  { id: 'Foco e memória', label: 'Foco e memória' },
  { id: 'Dores e inflamações', label: 'Dores e inflamações' },
  { id: 'Digestão e intestino', label: 'Digestão e intestino' },
  { id: 'Peso e metabolismo', label: 'Peso e metabolismo' },
  { id: 'Imunidade e proteção', label: 'Imunidade e proteção' },
  { id: 'Saúde respiratória', label: 'Saúde respiratória' },
  { id: 'Saúde da pele', label: 'Saúde da pele' },
]

export const PRIORIDADES_EMOCIONAIS: PrioridadeOpcao[] = [
  { id: 'Ansiedade e estresse', label: 'Ansiedade e estresse' },
  { id: 'Tristeza e apatia', label: 'Tristeza e apatia' },
  { id: 'Medo e insegurança', label: 'Medo e insegurança' },
  { id: 'Raiva e irritabilidade', label: 'Raiva e irritabilidade' },
  { id: 'Estagnação e bloqueios', label: 'Estagnação e bloqueios' },
  { id: 'Autoestima e merecimento', label: 'Autoestima e merecimento' },
  { id: 'Equilíbrio emocional geral', label: 'Equilíbrio emocional geral' },
]

// Grupos para iteração na UI
export const GRUPOS_PRIORIDADES: GrupoPrioridades[] = [
  { titulo: 'Saúde Física', opcoes: PRIORIDADES_FISICAS },
  { titulo: 'Equilíbrio Emocional', opcoes: PRIORIDADES_EMOCIONAIS },
]

/**
 * Filtra as prioridades visíveis com base nas respostas SIM do diagnóstico
 * e nas condições de saúde selecionadas.
 */
export function filtrarPrioridadesVisiveis(
  respostas: Record<string, boolean>,
  condicoes: string[] = []
): GrupoPrioridades[] {
  const sim = (key: string) => respostas[key] === true
  const temCondicao = (c: string) => condicoes.includes(c)

  // Regras do Grupo 1 — Saúde Física
  const fisicasVisiveis: PrioridadeOpcao[] = []

  if (sim('sono')) fisicasVisiveis.push({ id: 'Sono e descanso', label: 'Sono e descanso' })
  if (sim('disposicao')) fisicasVisiveis.push({ id: 'Energia e disposição', label: 'Energia e disposição' })
  if (sim('foco') || sim('memoria')) fisicasVisiveis.push({ id: 'Foco e memória', label: 'Foco e memória' })
  if (sim('dores') || sim('medicamentos') || sim('inflamacoes'))
    fisicasVisiveis.push({ id: 'Dores e inflamações', label: 'Dores e inflamações' })
  if (sim('intestino')) fisicasVisiveis.push({ id: 'Digestão e intestino', label: 'Digestão e intestino' })
  if (sim('peso')) fisicasVisiveis.push({ id: 'Peso e metabolismo', label: 'Peso e metabolismo' })
  if (sim('vergonha') || sim('apatia'))
    fisicasVisiveis.push({ id: 'Imunidade e proteção', label: 'Imunidade e proteção' })
  if (sim('tristeza') || temCondicao('Alergias respiratórias'))
    fisicasVisiveis.push({ id: 'Saúde respiratória', label: 'Saúde respiratória' })
  if (temCondicao('Sensibilidade na pele'))
    fisicasVisiveis.push({ id: 'Saúde da pele', label: 'Saúde da pele' })

  // Regras do Grupo 2 — Equilíbrio Emocional
  const emocionaisVisiveis: PrioridadeOpcao[] = []

  if (sim('ansiedade')) emocionaisVisiveis.push({ id: 'Ansiedade e estresse', label: 'Ansiedade e estresse' })
  if (sim('tristeza') || sim('apatia'))
    emocionaisVisiveis.push({ id: 'Tristeza e apatia', label: 'Tristeza e apatia' })
  if (sim('medo')) emocionaisVisiveis.push({ id: 'Medo e insegurança', label: 'Medo e insegurança' })
  if (sim('raiva')) emocionaisVisiveis.push({ id: 'Raiva e irritabilidade', label: 'Raiva e irritabilidade' })
  if (sim('estagnacao'))
    emocionaisVisiveis.push({ id: 'Estagnação e bloqueios', label: 'Estagnação e bloqueios' })
  if (sim('vergonha') || sim('culpa') || sim('escassez'))
    emocionaisVisiveis.push({ id: 'Autoestima e merecimento', label: 'Autoestima e merecimento' })
  if (sim('desequilibrio'))
    emocionaisVisiveis.push({ id: 'Equilíbrio emocional geral', label: 'Equilíbrio emocional geral' })

  const grupos: GrupoPrioridades[] = []
  if (fisicasVisiveis.length > 0) grupos.push({ titulo: 'Saúde Física', opcoes: fisicasVisiveis })
  if (emocionaisVisiveis.length > 0) grupos.push({ titulo: 'Equilíbrio Emocional', opcoes: emocionaisVisiveis })

  return grupos
}
